import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import styles from "./styles.module.css";
import { useEffect, useRef, useState } from "react";
import {
  buscarDadosCliente,
  buscarDadosParceiro,
  downloadArquivos,
} from "../../../services/api-planejamento-tributario.service";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import MensagemErro from "../../../components/MensagemErro";
import MensagemSucesso from "../../../components/MensagemSucesso";
import generatePDF from "react-to-pdf";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import styled from "styled-components";

const TextArea = styled.textarea`
  border-radius: 0.3rem;
  min-width: 30vw;
  min-height: 5rem;
  font-family: "inter";
  padding: 0.5rem;
  border-color: #c0c0c0;
  overflow: auto;
`;
const ModalVisualizar = ({ open, onClose, dadosUsuarios }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [dadosComplementares, setDadosComplementares] = useState(false);
  const formRef = useRef();
  const minDesktop = useMediaQuery("(max-width: 426px)");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let dados = "";
      switch (dadosUsuarios.tipo) {
        case "Parceiro":
          setDadosComplementares(true);
          {
            const responseP = await buscarDadosParceiro(dadosUsuarios.id);
            const listaUsuarios = responseP.data.dadosParceiro.idPai
              ? [
                  responseP.data.dadosParceiro.idUsuario,
                  responseP.data.dadosParceiro.idPai,
                ]
              : [responseP.data.dadosParceiro.idUsuario];
            const { dadosParceiro, procurador, ...restP } = responseP.data;
            const newResponseP = {
              ...restP,
              dados: dadosParceiro,
              dadosProcurador: procurador,
              listaUsuarios,
            };
            dados = newResponseP;
          }
          break;
        case "Cliente":
          setDadosComplementares(false);
          const responseC = await buscarDadosCliente(dadosUsuarios.id);
          const listaUsuarios = responseC.clientes[0].dadosCliente
            ?.idAssociadoPai
            ? [responseC.clientes[0].dadosCliente?.idAssociadoPai]
            : [responseC.clientes[0].dadosCliente?.idParceiroPai];
          const { dadosCliente, ...restC } = responseC.clientes[0];
          const newResponseC = { ...restC, dados: dadosCliente, listaUsuarios };
          dados = newResponseC;
          break;
        default:
          break;
      }
      console.log(dados);

      setData(dados);
      setLoading(false);
    };
    fetchData();
  }, [dadosUsuarios]);

  const getTargetElement = () => formRef.current;

  const handleExportPdf = async () => {
    const options = {
      filename: `${data.dados.nome}.pdf`,
      page: {
        margin: 10,
      },
    };
    generatePDF(getTargetElement, options);
  };

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };

  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const handleDownload = async (arquivo) => {
    const response = await downloadArquivos(
      data.dados.id,
      arquivo,
      dadosUsuarios.tipo.toLowerCase()
    );
    if (response.data.file) {
      const contentUint8Array = new Uint8Array(response.data.file.data);
      const blob = new Blob([contentUint8Array], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      setMsg("Arquivo inexistente!");
      setOpenSnackErro(true);
    }
  };

  const checkClienteStatus = () => {
    if (
      data &&
      (data.status == "ANALISANDO_CLIENTE" || data.status == "CADASTRARDET")
    )
      return false;

    return true;
  };

  return (
    <>
      {!loading ? (
        <Dialog open={open} onClose={onClose} maxWidth="lg">
          <DialogTitle className={styles.container_title}>
            <h3 className={styles.title}>
              <AssignmentIndIcon sx={{ marginRight: ".5rem" }} /> Informações
              Cadastradas
            </h3>
            <Button variant="outlined" onClick={handleExportPdf} color="error">
              <PictureAsPdfIcon sx={{ marginX: minDesktop ? ".5rem" : "" }} />
              {minDesktop ? "" : "EXPORTAR"}
            </Button>
          </DialogTitle>
          <DialogContent>
            <div ref={formRef}>
              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    1 - Dados do Cliente
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    disabled
                    value={data ? data.dados.nome : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    size="small"
                    label="CEP"
                    fullWidth
                    value={data ? data.dados.cep : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={5} md={6}>
                  <TextField
                    size="small"
                    label="Logradouro"
                    fullWidth
                    value={data ? data.dados.logradouro : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2} md={3}>
                  <TextField
                    size="small"
                    label="Bairro"
                    fullWidth
                    value={data ? data.dados.bairro : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <TextField
                    size="small"
                    label="Número"
                    fullWidth
                    value={data ? data.dados.numero : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <TextField
                    size="small"
                    label="Complemento"
                    fullWidth
                    value={data ? data.dados.complemento : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2} md={3}>
                  <TextField
                    size="small"
                    label="Cidade"
                    fullWidth
                    value={data ? data.dados.cidade : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2} md={1}>
                  <TextField
                    size="small"
                    label="Estado"
                    fullWidth
                    value={data ? data.dados.estado : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2} md={1}>
                  <TextField
                    size="small"
                    label="Pais"
                    fullWidth
                    value={data ? data.dados.pais : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.dados.cpf : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={5}>
                  <TextField
                    size="small"
                    label="E-mail"
                    value={data ? data.dados.email : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.dados.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.dados.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    2 - Responsável pela Empresa
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Nome"
                    value={data ? data.responsavelEmpresa.nome : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Profissão"
                    fullWidth
                    value={data ? data.responsavelEmpresa.profissao : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={5} sm={2}>
                  <FormControl>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      Estrangeiro?
                    </FormLabel>
                    <h5 style={{ margin: 0, color: "gray" }}>
                      {data ? data.responsavelEmpresa.estrangeiro : null}
                    </h5>
                  </FormControl>
                </Grid>

                <Grid item xs={7} sm={2}>
                  <TextField
                    size="small"
                    label="Tipo Documento"
                    value={data ? data.responsavelEmpresa.tipoDocumento : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Documento"
                    fullWidth
                    value={data ? data.responsavelEmpresa.documento : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Ramo de atividade"
                    fullWidth
                    value={data ? data.responsavelEmpresa.ramo : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="E-mail"
                    type="email"
                    value={data ? data.responsavelEmpresa.email : null}
                    disabled
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="NºOAB"
                    disabled
                    fullWidth
                    value={data ? data.responsavelEmpresa.oab : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="CRC"
                    fullWidth
                    value={data ? data.responsavelEmpresa.crc : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelEmpresa.telefone : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelEmpresa.whatsapp : null}
                    disabled
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      Alguém te Indicou?
                    </FormLabel>
                    <h5 style={{ margin: 0, color: "gray" }}>
                      {data ? data.responsavelEmpresa.foiIndicado : null}
                    </h5>
                  </FormControl>
                </Grid>
                {data ? (
                  data.responsavelEmpresa.foiIndicado === "SIM" ? (
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="small"
                        label="Indicado Por..."
                        fullWidth
                        disabled
                        value={
                          data ? data.responsavelEmpresa.indicadoPor : null
                        }
                        style={
                          {
                            // display: foiIndicadoResponsavel ? "block" : "none",
                          }
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    3 - Responsável Financeiro
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    4 - Responsável Legal
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.responsavelLegal.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.responsavelLegal.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.responsavelLegal.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelLegal.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelLegal.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    5 - Dados do Procurador
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.dadosProcurador.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.dadosProcurador.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.dadosProcurador.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.dadosProcurador.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.dadosProcurador.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    6 - Dados Bancários
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Banco"
                    fullWidth
                    value={data ? data.dadosBancarios.banco : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Agência"
                    fullWidth
                    disabled
                    value={data ? data.dadosBancarios.agencia : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="Conta"
                    fullWidth
                    disabled
                    value={data ? data.dadosBancarios.conta : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="PIX"
                    value={data ? data.dadosBancarios.pix : null}
                    fullWidth
                    disabled
                  />
                </Grid>
              </Grid>

              {dadosComplementares && (
                <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                  <Grid item xs={12} sm={12}>
                    <h4 className={styles.titulosConfirmacao}>
                      7 - Dados Complementares
                    </h4>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div className={styles.content__motiv}>
                      <h2 className={styles.titleMotivacao}>
                        Motivação do candidato
                      </h2>
                      <TextArea
                        value={data ? data.dadosComplementares.motivacao : null}
                        disabled
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div className={styles.content__motiv}>
                      <h2 className={styles.titleMotivacao}>
                        Tipos de Negócio
                      </h2>
                      <TextArea
                        value={
                          data ? data.dadosComplementares.tiposNegocio : null
                        }
                        disabled
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div className={styles.content__motiv}>
                      <h2 className={styles.titleMotivacao}>Comissionamento</h2>
                      <TextField
                        size="small"
                        value={
                          data
                            ? (data.dadosComplementares.contraproposta ??
                                "15") + "%"
                            : null
                        }
                        fullWidth
                        disabled
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div className={styles.content__motiv}>
                      <h2 className={styles.titleMotivacao}>Observação</h2>
                      <TextArea
                        value={
                          data ? data.dadosComplementares.observacao : null
                        }
                        disabled
                      />
                    </div>
                  </Grid>
                </Grid>
              )}
            </div>
            {checkClienteStatus() && (
              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    8 - Anexo de Documentos
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("rg")}
                  >
                    <CloudDownloadIcon />
                    <span> RG</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("cpf")}
                  >
                    <CloudDownloadIcon />
                    <span> CPF</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("comprovante_residencia")}
                  >
                    <CloudDownloadIcon />
                    <span> Comp. Residência</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("passaporte")}
                  >
                    <CloudDownloadIcon />
                    <span> Passaporte</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("rne")}
                  >
                    <CloudDownloadIcon />
                    <span> RNE</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("cpf_socios")}
                  >
                    <CloudDownloadIcon />
                    <span> CPF dos Sócios</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() =>
                      handleDownload("comprovante_residencia_socios")
                    }
                  >
                    <CloudDownloadIcon />
                    <span> Comp. Residência Sócios</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() =>
                      handleDownload("comprovante_residencia_empresa")
                    }
                  >
                    <CloudDownloadIcon />
                    <span> Comp. Residência Empresa</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("contrato_social")}
                  >
                    <CloudDownloadIcon />
                    <span> Contrato Social</span>
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} className={styles.btnContainer}>
                  <Button
                    className={styles.btnDownload}
                    onClick={() => handleDownload("cartao_cnpj")}
                  >
                    <CloudDownloadIcon />
                    <span> Cartão CNPJ</span>
                  </Button>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Grid container spacing={{ sm: 1, xs: 1 }}>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  onClick={onClose}
                  className={styles.btnFechar}
                  fullWidth
                >
                  Fechar
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}

      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </>
  );
};

export default ModalVisualizar;
